<template>
	<v-card elevation="0">
		<v-card-text>
			<v-form>
				<v-row dense>
					<v-col cols="12" md="3">
						<v-card elevation="0" class="px-2">
							<v-row>
								<v-col cols="12" md="12">
									<v-text-field v-model="form.nombre" label="Nombre" autocomplete="new" required
										prepend-icon="mdi-account" :error-messages="nombreErrores"
										@blur="$v.form.nombre.$touch()"></v-text-field>
								</v-col>
							</v-row>
						</v-card>
					</v-col>
					<v-col cols="12" md="3">
						<v-row dense>
							<v-col>
								<v-card elevation="0" class="px-2">
									<v-select v-model="form.estadoCliente" :items="
										opciones
											? opciones.cliente.estado
											: []
									" label="Estado cliente" item-text="human" item-value="encoded" required single-line clearable
										prepend-icon="mdi-state-machine"></v-select>
								</v-card>
							</v-col>
						</v-row>
					</v-col>
					<v-col md="3">
						<v-row dense>
							<v-col cols="12">
								<v-card elevation="0" class="px-2">
									<v-text-field v-model="form.telefono" label="Móvil" prepend-icon="mdi-cellphone"
										:error-messages="telefonoErrores" type="number" counter="9"
										@blur="$v.form.telefono.$touch()"></v-text-field>
								</v-card>
							</v-col>
						</v-row>
					</v-col>
					<v-col cols="12" md="3">
						<v-card class="px-2" elevation="0">
							<v-row align-self="center">
								<!-- <v-col cols="12" md="5">
                                <v-select
                                    v-model="form.tipoDocumento"
                                    :items="documentoTipo"
                                    label="Documento"
                                    required
                                    single-line
                                    prepend-icon="mdi-card-account-details"
                                    :label="form.tipoDocumento"
                                    :error-messages="
                                        documentoErrores
                                    "
                                ></v-select>
                            </v-col>
                            <v-spacer></v-spacer> -->
								<v-col cols="12" md="12">
									<v-text-field v-model="form.documento" label="Documento"
										prepend-icon="mdi-card-account-details" required
										@blur="$v.form.documento.$touch()"></v-text-field>
								</v-col>
							</v-row>
						</v-card>
					</v-col>
				</v-row>
				<v-row dense>
					<v-col cols="12" md="3">
						<v-card class="px-2" elevation="0">
							<v-text-field v-model="form.cups" label="CUPS" prepend-icon="mdi-home-lightning-bolt-outline" required
								:error-messages="cupsErrores" @blur="$v.form.cups.$touch()"></v-text-field>
						</v-card>
					</v-col>
					<v-col cols="12" md="3">
						<v-card class="px-2" elevation="0">
							<v-text-field v-model="form.email" :error-messages="emailErrores" prepend-icon="mdi-email"
								label="E-mail" required @blur="$v.form.email.$touch()"></v-text-field>
						</v-card>
					</v-col>
					<v-col cols="12" md="6">
						<v-card elevation="0" class="px-2">
							<v-row>
								<v-col cols="12" md="5">
									<v-text-field :error-messages="cpErrores" v-model="form.cp" label="CP" required
										type="number" prepend-icon="mdi-map-marker" @blur="$v.form.cp.$touch()">
									</v-text-field>
								</v-col>
								<v-col cols="12" md="7">
									<v-text-field v-model="form.localidad" prepend-icon="mdi-map-search"
										label="Localidad" required :error-messages="localidadErrores"
										@blur="$v.form.localidad.$touch()">
									</v-text-field>
								</v-col>
							</v-row>
						</v-card>
					</v-col>
				</v-row>
				<v-row no-gutters class="mt-2">
					<v-card elevation="0" class="px-2" style="width: 100%">
						<v-row>
							<v-col cols="12" md="4" class="pb-0">
								<v-autocomplete v-model="origenBbdd" :items="origenBbddTipo" label="Origen BBDD" :chips="
									form.origenBbdd
										? form.origenBbdd.length >= 1
										: false
								" :dense="false" item-text="nombre" multiple clearable autocomplete="new" deletable-chips
									prepend-icon="mdi-database">
									<template v-slot:item="{ index, item }">
										<v-list-item @click.stop="addOrigComboBox(item)">{{ item.nombre }}</v-list-item>
									</template>
									<template v-slot:selection="{ index, item }">
										<v-chip close @click:close="
											deleteOrigComboBox(item)
										">{{ item.nombre }}</v-chip>
									</template>
								</v-autocomplete>
							</v-col>
							<v-col cols="12" md="4" class="pb-0">
								<v-autocomplete v-model="form.segmento" :items="
									opciones
										? opciones.cliente.segmento
										: []
								" label="Segmento" :dense="false" multiple clearable autocomplete="new" deletable-chips chips
									item-text="human" item-value="encoded" prepend-icon="mdi-clipboard-list-outline"
									@blur="$v.form.segmento.$touch()" :return-object="false"
									:error-messages="segmentoErrores">
								</v-autocomplete>
							</v-col>
							<v-col cols="12" md="4" class="pb-0">
								<v-autocomplete :dense="false" v-model="form.ispActual" :items="
									opciones ? opciones.cliente.isp : []
								" item-text="human" item-value="encoded" label="Operador" required chips deletable-chips clearable
									prepend-icon="mdi-server-network" @blur="$v.form.isp.$touch()"
									:error-messages="ispErrores"></v-autocomplete>
							</v-col>
						</v-row>
					</v-card>
				</v-row>
			</v-form>
		</v-card-text>
	</v-card>
</template>

<script>
import { email, maxLength, minLength } from 'vuelidate/lib/validators';
import { valid_nif, valid_nie, valid_cif } from '@/validators';
import { ofertaTipo, documentoTipo } from '@/util/optionsTtForm.json';
import {
	nombreErrores,
	documentoErrores,
	telf_fijoErrores,
	telf_movilErrores,
	telefonoErrores,
	emailErrores,
	cupsErrores,
	direccionErrores,
	cpErrores,
	localidadErrores,
	origenBbddErrores,
	segmentoErrores,
	comercialErrores,
	ispErrores,
	estadoErrores,
	ofertaErrores,
} from './errorHandlers';

import { defaultTtForm } from '@/util/defaultTtForm';

import {
	swapKeysAndValues,
	objectCamelToSnakeCase,
	clone,
} from '@/util/libUtil.js';

let local_defaultTtForm = JSON.parse(JSON.stringify(defaultTtForm));
local_defaultTtForm.fecha_contacto = [];
local_defaultTtForm.updated_on = [];
local_defaultTtForm.fecha_agendado = [];
local_defaultTtForm.fecha_venta = [];
local_defaultTtForm.tipo_document = null;

import { mapState, mapGetters } from 'vuex';

export default {
	name: 'ClientDataFilters',

	data: () => ({
		estadoComercial: {
			ALTA: 'success',
			BAJA: 'warning',
			INACTIVO: 'error',
			VACACIONES: 'blue',
		},
		comercial_nombre: '',
		bools: {
			fecha_contacto: false,
			updated_on: false,
			fecha_agendado: false,
			fecha_venta: false,
			fecha_contacto_isNull: false,
			updated_on_isNull: false,
			fecha_agendado_isNull: false,
			fecha_venta_isNull: false,
			menu_telf: false,
		},
		last_fecha_contacto: [],
		last_updated_on: [],
		last_fecha_agendado: [],
		last_fecha_venta: [],
		documentoTipo,
		comerciales: [],
		ofertaTipo,
		dialog: true,
		uploading_form: false,
		OfferComboBoxFilter: function (item, queryText, itemText) {
			itemText = item.name;
			return (
				itemText
					.toLocaleLowerCase()
					.indexOf(queryText.toLocaleLowerCase()) > -1
			);
		},
	}),
	validations() {
		let valid_document = true;
		let regexTelefono = /^(6|7|8|9)([0-9]){8}$/;
		let validTelefono = () => {
			if (!this.form.telefono) {
				return true;
			}

			return regexTelefono.test(this.form.telefono);
		};

		let form = {
			nombre: {
				required: false,
				max: maxLength(25),
			},
			documento: {
				required: false,
				max: maxLength(30),
				valid_document,
			},
			telefono: {
				validTelefono,
			},
			email: {
				email,
			},
			cups: {
				required: false,
				max: maxLength(22),
				min: minLength(20),
			},
			cp: {
				required: false,
				max: maxLength(5),
				min: minLength(5),
			},
			localidad: {
				required: false,
			},
			fecha_contacto: {
				required: false,
			},
			updated_on: {
				required: false,
			},
			orig_bbdd: {
				required: false,
			},
			segmento: {
				required: false,
			},
			comercial: {
				required: false,
			},
			isp: {
				required: false,
			},
			estado: {
				required: false,
			},
			oferta: {
				required: false,
			},
		};
		return {
			form,
		};
	},
	computed: {
		nombreErrores,
		documentoErrores,
		telf_fijoErrores,
		telf_movilErrores,
		emailErrores,
		cupsErrores,
		direccionErrores,
		cpErrores,
		localidadErrores,
		origenBbddErrores,
		segmentoErrores,
		comercialErrores,
		ispErrores,
		estadoErrores,
		ofertaErrores,
		telefonoErrores,
		telf_label() {
			return (
				this.form.telf_movil +
				(this.form.telf_movil && this.form.telf_fijo ? '-' : '') +
				this.form.telf_fijo
			);
		},
		cp() {
			return this.form.cp;
		},
		cuenta() {
			return JSON.parse(localStorage.getItem('cuenta'));
		},
		dialogState: {
			get: function () {
				return this.$store.state.teletrabajo.IsOpenTtQueryDialog;
			},
			set: function (val) {
				this.$store.dispatch('teletrabajo/closeTtQueryDialog', val);
			},
		},
		form_comercial: {
			set: function (val) {
				this.form.comercial = val
					? this.comerciales_dict.filter(
							(el) => el.nombreCompleto == val
					  )[0].id
					: null;
				if (!this.form.comercial) {
					this.form.comercial = null;
				}
			},
			get: function () {
				return this.form.comercial?.nombreCompleto;
			},
		},
		fecha_contacto: {
			get: function () {
				if (this.bools.fecha_contacto_isNull === 0)
					return 'Sin fecha de contacto';

				if (
					!this.form.fecha_contacto[0] ||
					this.form.fecha_contacto === 'null'
				)
					return '';
				const [year, month, day] =
					this.form.fecha_contacto[0].split('-');
				if (!this.form.fecha_contacto[1])
					return `${day}/${month}/${year}`;

				const [year2, month2, day2] =
					this.form.fecha_contacto[1].split('-');
				return (
					`${day}/${month}/${year}` +
					' ~ ' +
					`${day2}/${month2}/${year2}`
				);
			},
			set: function (val) {
				if (!val) {
					val = [];
				}
				this.form.fecha_contacto = val;
			},
		},
		updated_on: {
			get: function () {
				if (this.bools.updated_on_isNull === 0)
					return 'Sin fecha de contacto';

				if (!this.form.updated_on[0] || this.form.updated_on === 'null')
					return '';
				const [year, month, day] = this.form.updated_on[0].split('-');
				if (!this.form.updated_on[1]) return `${day}/${month}/${year}`;

				const [year2, month2, day2] =
					this.form.updated_on[1].split('-');
				return (
					`${day}/${month}/${year}` +
					' ~ ' +
					`${day2}/${month2}/${year2}`
				);
			},
			set: function (val) {
				if (!val) {
					val = [];
				}
				this.form.updated_on = val;
			},
		},
		fecha_agendado: {
			get: function () {
				if (this.bools.fecha_agendado_isNull === 0)
					return 'Sin fecha de agendado';

				if (
					!this.form.fecha_agendado[0] ||
					this.form.fecha_agendado === 'null'
				)
					return '';
				const [year, month, day] =
					this.form.fecha_agendado[0].split('-');
				if (!this.form.fecha_agendado[1])
					return `${day}/${month}/${year}`;
				const [year2, month2, day2] =
					this.form.fecha_agendado[1].split('-');
				return (
					`${day}/${month}/${year}` +
					' ~ ' +
					`${day2}/${month2}/${year2}`
				);
			},
			set: function (val) {
				if (!val) {
					val = [];
				}
				this.form.fecha_agendado = val;
			},
		},
		fecha_venta: {
			get: function () {
				// console.log(this.form.fecha_venta)
				if (this.bools.fecha_venta_isNull === 0)
					return 'Sin fecha de venta';

				if (
					!this.form.fecha_venta[0] ||
					this.form.fecha_venta === 'null'
				)
					return '';
				const [year, month, day] = this.form.fecha_venta[0].split('-');
				if (!this.form.fecha_venta[1]) return `${day}/${month}/${year}`;
				const [year2, month2, day2] =
					this.form.fecha_venta[1].split('-');
				return (
					`${day}/${month}/${year}` +
					' ~ ' +
					`${day2}/${month2}/${year2}`
				); // return ''
			},
			set: function (val) {
				if (!val) {
					val = [];
				}
				this.form.fecha_venta = val;
			},
		},
		cups: {
			get() {
				return this.form.cups;
			},
			set(val) {
				this.form.cups = val;
			},
		},
		isp: {
			get() {
				return this.decodeIsp[this.form.ispActual];
			},
			set(val) {
				this.form.ispActual = this.encodeIsp[val];
			},
		},
		fecha_contacto_picker: {
			get: function () {
				if (this.form.fecha_contacto === 'null') return [];
				return this.form.fecha_contacto;
			},
			set(val) {
				this.fecha_contacto = val;
			},
		},
		updated_on_picker: {
			get: function () {
				if (this.form.updated_on === 'null') return [];
				return this.form.updated_on;
			},
			set(val) {
				this.updated_on = val;
			},
		},
		fecha_venta_picker: {
			get() {
				if (this.form.fecha_venta === 'null') return [];
				return this.form.fecha_venta;
			},
			set(val) {
				this.fecha_venta = val;
			},
		},
		fecha_agendado_picker: {
			get() {
				if (this.form.fecha_agendado === 'null') return [];
				return this.form.fecha_agendado;
			},
			set(val) {
				this.fecha_agendado = val;
			},
		},
		fecha_agendado_isNull() {
			return this.bools.fecha_agendado_isNull;
		},
		fecha_contacto_isNull() {
			return this.bools.fecha_contacto_isNull;
		},
		updated_on_isNull() {
			return this.bools.updated_on_isNull;
		},
		fecha_venta_isNull() {
			return this.bools.fecha_venta_isNull;
		},
		origenBbdd: {
			get() {
				return this.form.origenBbdd.map((id) =>
					this.origenBbddTipo.find((orig) => orig.id == id)
				);
			},
			set(val) {
				// Si se hace un set se esta cleareando el campo
				this.form.origenBbdd = [];
			},
		},
		form: {
			get: function () {
				return this.$store.state.teletrabajo.QueryForm;
			},
			set: function (val) {
				this.$store.commit('teletrabajo/QueryForm', val);
			},
		},
		opciones() {
			return JSON.parse(localStorage.getItem('opciones'));
		},
		origenBbddTipo() {
			return JSON.parse(localStorage.getItem('origenesBbdd'));
		},
		opcionesTipoLlamada() {
			return this.opciones.noInteresado.tipo;
		},
		opcionesNoInteresado() {
			return this.opciones.noInteresado.razon;
		},
		...mapState('util', {
			opcionesEstadoCliente: (state) =>
				state.opciones
					? Object.values(state.opciones.atencion.tipo)
					: [],
			encodeEstadoCliente: (state) =>
				state.opciones
					? swapKeysAndValues(state.opciones.atencion.tipo)
					: {},
			decodeEstado: (state) =>
				state.opciones ? state.opciones.atencion.tipo : {},

			opcionesSegmento: (state) =>
				state.opciones
					? Object.values(state.opciones.cliente.segmento)
					: [],

			opcionesIsp: (state) =>
				state.opciones ? Object.values(state.opciones.cliente.isp) : [],
			encodeIsp: (state) =>
				state.opciones
					? swapKeysAndValues(state.opciones.cliente.isp)
					: {},
			decodeIsp: (state) =>
				state.opciones ? state.opciones.cliente.isp : {},
		}),
		...mapGetters('teletrabajo', {
			comerciales_dict: 'allComerciales',
		}),
		...mapGetters('login', {
			isComercialCobOrRec: 'isComercialCobOrRec',
		}),
	},
	methods: {
		close() {
			this.$v.$reset();
			this.$store.dispatch('teletrabajo/closeTtQueryDialog');
			//this.clear();
		},
		async clearform() {
			await this.$store.dispatch('teletrabajo/setDefaultQueryForm');
			let monParams = objectCamelToSnakeCase(this.form);

			// encodeQuery(monParams)
			monParams.page = 1;
			this.uploading_form = true;
			this.$store.dispatch('teletrabajo/updateQueryParams', monParams);
			this.bools = {
				fecha_contacto: false,
				updated_on: false,
				fecha_agendado: false,
				fecha_venta: false,
				fecha_contacto_isNull: false,
				updated_on_isNull: false,
				fecha_agendado_isNull: false,
				fecha_venta_isNull: false,
				menu_telf: false,
			};
			this.last_fecha_contacto = [];
			this.last_updted_on = [];
			this.last_fecha_agendado = [];
			this.last_fecha_venta = [];
			this.$store
				.dispatch('teletrabajo/getTableData')
				.then(() => {
					this.uploading_form = false;
				})
				.catch(() => {
					this.uploading_form = false;
				});
			this.uploading_form = true;
		},
		addOrigComboBox(item) {
			let isContained = this.form.origenBbdd.some((el) => el == item.id);

			if (!isContained) this.form.origenBbdd.push(item.id);
		},
		deleteOrigComboBox(item) {
			let index = this.form.origenBbdd.findIndex((el) => el == item.id);

			if (index != -1) this.form.origenBbdd.splice(index, 1);
		},
		orderDates(arr) {
			let date_from = new Date(arr[0]);
			let date_to = new Date(arr[1]);
			if (date_from > date_to) {
				let c = arr[0];
				arr[0] = arr[1];
				arr[1] = c;
			}
			return arr;
		},
	},
	watch: {
		comerciales_dict: {
			immediate: true,
			handler: function () {
				this.comerciales = this.comerciales_dict.map(
					({ nombreCompleto }) => nombreCompleto
				);
			},
		},
		fecha_agendado_isNull() {
			if (this.bools.fecha_agendado_isNull == 0) {
				this.last_fecha_agendado = this.form.fecha_agendado;
				this.form.fecha_agendado = 'null';
			} else {
				this.form.fecha_agendado = this.last_fecha_agendado;
			}
		},
		fecha_contacto_isNull() {
			if (this.bools.fecha_contacto_isNull == 0) {
				this.last_fecha_contacto = this.form.fecha_contacto;
				this.form.fecha_contacto = 'null';
			} else {
				this.form.fecha_contacto = this.last_fecha_contacto;
			}
		},
		updated_on_isNull() {
			if (this.bools.updated_on_isNull == 0) {
				this.last_updated_on = this.form.updated_on;
				this.form.updated_on = 'null';
			} else {
				this.form.updated_on = this.last_updated_on;
			}
		},
		fecha_venta_isNull() {
			if (this.bools.fecha_venta_isNull == 0) {
				this.last_fecha_venta = this.form.fecha_venta;
				this.form.fecha_venta = 'null';
			} else {
				this.form.fecha_venta = this.last_fecha_venta;
			}
		},
		form: {
			deep: true,
			immediate: true,
			handler: function () {
				if (this.form.fecha_contacto[1]) {
					this.form.fecha_contacto = this.orderDates(
						this.form.fecha_contacto
					);
				}
				if (this.form.updated_on[1]) {
					this.form.updated_on = this.orderDates(
						this.form.updated_on
					);
				}
				if (this.form.fecha_agendado[1]) {
					this.form.fecha_agendado = this.orderDates(
						this.form.fecha_agendado
					);
				}
				if (this.form.fecha_venta[1]) {
					this.form.fecha_venta = this.orderDates(
						this.form.fecha_venta
					);
				}
				if (
					this.form.opciones_tipo_llamada &&
					this.form.opciones_tipo_llamada == 'NC'
				) {
					if (this.form.opciones_no_interesado) {
						this.form.opciones_no_interesado = null;
					}
				}
			},
		},
	},
	updated() {
		let filters = 0;
		let fields = [
			'nombre',
			'estadoCliente',
			'telefono',
			'email',
			'cp',
			'localidad',
			'segmento',
			'ispActual',
		];

		Object.keys(this.form).forEach((field) => {
			if (
				fields.includes(field) &&
				this.form[field] &&
				this.form[field]?.length
			)
				filters += 1;
		});

		if (this.origenBbdd.length) filters += 1;
		this.$root.$emit('clientFilters', filters);
	},
	mounted() {
		this.$root.$on('deleteTableFilters', () => {
			this.clearform();
		});

		if (!this.comerciales.length) {
			this.$store.dispatch('teletrabajo/fetchComerciales');
		}
		if (this.form.comercial) {
			this.form_comercial = this.form.comercial.nombre;
		}
	},
};
</script>
<style>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
}

/* Firefox */
input[type='number'] {
	-moz-appearance: textfield;
}
</style>